namespace TabAurous.OMS {
    export interface RewardsMasterForm {
        RewardCode: Serenity.StringEditor;
        CustomerCategoryId: Serenity.LookupEditor;
        ExchangeRate: Serenity.DecimalEditor;
        MobilePoints: Serenity.IntegerEditor;
        EmailPoints: Serenity.IntegerEditor;
        ReferencePoints: Serenity.IntegerEditor;
        ProductWise: Serenity.BooleanEditor;
        PurchaseValue: Serenity.DecimalEditor;
        RewardsDetails: RewardsDetailsEditor;
    }

    export class RewardsMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.RewardsMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RewardsMasterForm.init)  {
                RewardsMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.BooleanEditor;
                var w5 = RewardsDetailsEditor;

                Q.initFormType(RewardsMasterForm, [
                    'RewardCode', w0,
                    'CustomerCategoryId', w1,
                    'ExchangeRate', w2,
                    'MobilePoints', w3,
                    'EmailPoints', w3,
                    'ReferencePoints', w3,
                    'ProductWise', w4,
                    'PurchaseValue', w2,
                    'RewardsDetails', w5
                ]);
            }
        }
    }
}
